// Modules
import cn from 'classnames';

// Types
import type { TIconProps } from "./Icon.type";

// Styles
import styles from './styles.module.scss';

// Constants
import { ICON_DEFAULT_PROPS } from "./Icon.constant";

const Icon = (props: TIconProps) => {
	const {
		className,
		color = ICON_DEFAULT_PROPS.color,
		icon = ICON_DEFAULT_PROPS.icon,
		size = ICON_DEFAULT_PROPS.size,
		...restProps
	} = props;
	const iconKey = `ic-${icon!}`;

	const iconCN = cn(styles.legion_icon, className, styles[iconKey], styles[`ic-${icon}`], styles[color!], styles[size!]);

	return (
		<i
			className={iconCN}
			{...restProps}
		/>
	)
}

export default Icon;
